import React, { useState } from 'react'
import { useDispatch, useStore, useSelector } from 'react-redux'
import {
  Card,
  Table,
  Button,
  Select,
  Row,
  Col,
  Form,
  Spin,
  message
} from 'antd'
import IntlMessages from '../../../util/IntlMessages'
import ds from '../../../Services/DataServices'
import Skeleton from 'react-loading-skeleton'
import { useHistory } from 'react-router-dom'
import { setCommonConfigs } from '../../../appRedux/actions/CommonData'
import { REPORT_CLOSURE } from '../../../constants/Pages'
import {
  isEmptyObject,
  checkRightspermissions,
  getDecryptID,
  notAllowMsgCheck,
  formatDigits,
  verifyPkgFeature
} from '../../../appRedux/actions/GlobalMethods'
import { BEHAVIOUR_TYPE } from '../../../Services/DataServices'
import moment from 'moment'
import { CarryOutFilled } from '@ant-design/icons'
import { PostAppTypes } from '../../../constants/MobAppConstants'
import { checkIsWeb, postDataToApp } from '../../../appRedux/actions/MobAppFn'
import NotAllowedComponent from '../../../components/NotAllowedComponent'
import { PkgFeatures } from '../../../constants/StoreEntities'

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 24 }
  }
}

const RegisterClosuresListing = ({ match }) => {
  const [form] = Form.useForm()
  const history = useHistory()
  const dispatch = useDispatch()

  const getReduxCommonSetting = useSelector(
    ({ commonConfigs }) => commonConfigs.pageCommonConfigs
  )
  const getReduxStoreOutlets = useSelector(
    ({ Sell }) => Sell.openCloseStoreOutlets
  )
  const getReduxOutletReg = useSelector(({ Sell }) => Sell.openCloseOutletReg)
  const getDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  )
  const getIsStoreCreditEnabled = useSelector(
    ({ MainSale }) => MainSale.getIsStoreCreditEnabled
  )
  const getIsLoyaltyEnabled = useSelector(
    ({ MainSale }) => MainSale.getIsLoyaltyEnabled
  )

  const [getPagination, setPagination] = React.useState({
    CurrentPageNo: 1,
    PageSize: 10,
    showSizeChanger: true
    // IsCurrent: true,
  })

  const defColumns = [
    {
      title: <IntlMessages id='reporting.registerclosures.register' />,
      dataIndex: 'register',
      key: 'register'
    },
    {
      title: <IntlMessages id='reporting.registerclosures.hash' />,
      dataIndex: 'hash',
      key: 'hash'
    },
    {
      title: <IntlMessages id='reporting.registerclosures.timeopened' />,
      dataIndex: 'timeOpened',
      key: 'timeOpened',
      render: (text, record) => (
        <span>
          <a
            onClick={() =>
              history.push(
                `/dashboard/reporting/registerclosures/summary/${record.cashManagementID}`,
                record
              )
            }
            // href={"/Dashboard/products/supplier/view/" + record.key}
            className='gx-link'
          >
            {text}
          </a>
        </span>
      )
    },
    {
      title: <IntlMessages id='reporting.registerclosures.timeclosed' />,
      dataIndex: 'timeClosed',
      key: 'timeClosed'
    },
    {
      title: <IntlMessages id='reporting.registerclosures.storecredit' />,
      dataIndex: 'storeCredit',
      key: 'storeCredit'
    },
    {
      title: <IntlMessages id='reporting.registerclosures.loyalty' />,
      dataIndex: 'loyalty',
      key: 'loyalty'
    },
    {
      title: <IntlMessages id='reporting.registerclosures.total' />,
      dataIndex: 'total',
      key: 'total'
    }
  ]

  const [isLoading, setIsLoading] = React.useState(true)
  const [getRegClosureData, setRegClosureData] = React.useState([])
  const [getOutRegData, setOutRegData] = React.useState([])
  const [getRegData, setRegData] = React.useState([])
  const [getCol, setCol] = React.useState([])
  const [getLoadingTable, setLoadingTable] = useState(true)
  const [tabLoader, setTabLoader] = useState(true)
  // const [getRegID, setRegID] = useState("");
  // const [getOutletID, setOutletID] = useState("");
  const [getIsDisableCreate, setIsDisableCreate] = useState(true)
  const [getIsDisableUpdate, setIsDisableUpdate] = useState(true)
  const [getIsDisableDelete, setIsDisableDelete] = useState(true)
  const [getIsAllowRead, setIsAllowRead] = useState(false)
  const [getAccessLoading, setAccessLoading] = useState(true)
  const [getOutletDisabled, setOutletDisabled] = useState(false)
  const [getRights, setRights] = useState([])
  const [getPermissions, setPermissions] = useState([])
  const [getCurrData, setCurrData] = useState({
    currencyCode: '',
    currencySymbol: ''
  })
  const [columns, setColumns] = React.useState(defColumns)
  const [isFeatureAllowed, setIsFeatureAllowed] = useState(true)

  React.useEffect(() => {
    if (!verifyPkgFeature(PkgFeatures.ReportingAndAnalytics)) {
      setIsFeatureAllowed(false)
    }

    if (!checkIsWeb().exist) {
      postDataToApp(PostAppTypes.PAGE_HEADER, 'report.register.closure')
    }
    let mounted = true
    if (mounted) {
      dispatch(setCommonConfigs(REPORT_CLOSURE))
      getRegClosureListingService(
        getPagination,
        PkgFeatures.ReportingAndAnalytics
      )
      getRepOutletsRegistersService(PkgFeatures.ReportingAndAnalytics)
    }
    return () => (mounted = false)
  }, [])

  //for common data -> store currency
  React.useEffect(() => {
    let mounted = true
    if (mounted) {
      const commonData = getReduxCommonSetting
      const respData =
        commonData &&
        commonData.storeCommonConfigs &&
        commonData.storeCommonConfigs.storeConfig
          ? commonData.storeCommonConfigs.storeConfig
          : {}
      if (respData && respData.currencyData) {
        let currencyData = respData.currencyData
        setCurrData(currencyData)
      }
      // rights && permissions
      if (commonData && commonData.storeCommonConfigs) {
        const rpData = checkRightspermissions(commonData)
        if (rpData && !isEmptyObject(rpData)) {
          setupRightsPermissions(rpData)
          setAccessLoading(false)
        } else {
          toInitialState()
          setAccessLoading(false)
        }
      }
    }

    return () => (mounted = false)
  }, [getReduxCommonSetting])

  // React.useEffect(() => {
  //   let mounted = true;
  //   if (mounted) {
  //     let definedCol = columns;
  //     if (!getIsStoreCreditEnabled) {
  //       definedCol = definedCol.filter((a) => a.key !== "storeCredit");
  //     }
  //     if (!getIsLoyaltyEnabled) {
  //       definedCol = definedCol.filter((a) => a.key !== "loyalty");
  //     }
  //     setColumns(definedCol);
  //   }
  //   return () => (mounted = false);
  // }, [getIsStoreCreditEnabled, getIsLoyaltyEnabled]);

  function setupRightsPermissions (rpData) {
    if (rpData.rights && rpData.rights.length > 0) {
      setRights(rpData.rights)
    } else {
      setRights([])
    }
    if (rpData.permissions && rpData.permissions.length > 0) {
      setPermissions(rpData.permissions)
    } else {
      setPermissions([])
    }
    if (rpData.read) {
      setIsAllowRead(true)
    } else {
      setIsAllowRead(false)
    }
    if (rpData.create) {
      setIsDisableCreate(false)
    } else {
      setIsDisableCreate(true)
    }
    if (rpData.update) {
      setIsDisableUpdate(false)
    } else {
      setIsDisableUpdate(true)
    }
    if (rpData.delete) {
      setIsDisableDelete(false)
    } else {
      setIsDisableDelete(true)
    }
  }

  function toInitialState () {
    setRights([])
    setPermissions([])
    setIsAllowRead(false)
    setIsDisableCreate(true)
    setIsDisableUpdate(true)
    setIsDisableDelete(true)
    setAccessLoading(true)
  }

  async function getRegClosureListingService (body, featureID) {
    await ds
      .getRegClosureLisitng(body, BEHAVIOUR_TYPE.GET, featureID)
      .then(data => {
        // setIsLoading(false);
        setLoadingTable(false)
        setTabLoader(false)
        if (data && !isEmptyObject(data)) {
          if (data.closureLists && data.closureLists.length > 0) {
            const rr = data.closureLists.map((w, i) => {
              return {
                id: i,
                register: w.register,
                cashManagementID: w.cashManagementID,
                cash: w.cash,
                hash: w.closure,
                isOpen: w.isOpen,
                outletID: w.outletID,
                regID: w.regID,
                difference: formatDigits(w.difference, getDecimalPlaces),
                storeCredit: formatDigits(w.storeCredit, getDecimalPlaces),
                loyalty: formatDigits(w.loyalty, getDecimalPlaces),
                total: formatDigits(w.total, getDecimalPlaces),
                timeClosed: !w.isOpen
                  ? moment(w.timeClosed).format('MMMM DD/YYYY h:mma')
                  : 'Still Open',
                timeOpened: moment(w.timeOpened).format('MMMM DD/YYYY h:mma'),
                outlet: w.outlet ? w.outlet : '',
                payTypes: w.payTypes
              }
            })
            const paginationobj = {
              CurrentPageNo: data.closureLists[0].currentPageNo,
              // PageSize: data.closureLists[0].pageSize,
              total: data.closureLists[0].totalRecords,
              showSizeChanger: true
              // IsCurrent: true,
            }
            setPagination(paginationobj)
            setRegClosureData(rr)
          } else setRegClosureData([])
          if (data.payList && data.payList.length > 0) {
            let definedCol = defColumns.filter(a => a.key !== 'total')
            if (!data.isStoreEnabled) {
              definedCol = definedCol.filter(a => a.key !== 'storeCredit')
            }
            if (!data.isLoyaltyEnabled) {
              definedCol = definedCol.filter(a => a.key !== 'loyalty')
            }
            const endObj = {
              title: 'Total',
              dataIndex: 'total',
              key: 'total'
            }
            const pays = data.payList.map((mn, i) => {
              return {
                title: mn.paymentTypeName,
                dataIndex: mn.paymentTypeName,
                key: mn.paymentTypeName,
                render: (text, record) => {
                  let exp = 0
                  let count = 0
                  let diff = 0
                  if (record.payTypes && record.payTypes.length > 0) {
                    let da = record.payTypes.filter(
                      qq =>
                        getDecryptID(qq.paymentTypeID) ==
                        getDecryptID(mn.paymentTypeSId)
                    )
                    if (da && da.length > 0) {
                      da = da[0]
                      exp = formatDigits(da.expected, getDecimalPlaces)
                      count = formatDigits(da.counted, getDecimalPlaces)
                      // diff = formatDigits(da.difference, getDecimalPlaces);
                      diff = da.difference
                    }
                  }
                  return record.isOpen ? (
                    <div>
                      <Row>
                        <Col>{exp}</Col>
                      </Row>
                    </div>
                  ) : (
                    <div>
                      <Row>
                        <Col>{count}</Col>
                      </Row>
                      <Row>
                        <Col>
                          <strong
                            style={{
                              fontSize: 10,
                              color:
                                diff >= 0
                                  ? 'rgb(65, 175, 75)'
                                  : 'rgb(215, 113, 115)'
                            }}
                          >
                            {diff > 0
                              ? `(+${formatDigits(diff, getDecimalPlaces)})`
                              : diff == 0
                              ? ''
                              : `(${formatDigits(diff, getDecimalPlaces)})`}
                          </strong>
                        </Col>
                      </Row>
                    </div>
                  )
                }
              }
            })

            pays.map(rr => {
              definedCol.push(rr)
            })
            definedCol.push(endObj)
            setColumns(definedCol)
          }
        } else {
          setRegClosureData([])
        }
      })
      .catch(e => {
        setTabLoader(false)
        setLoadingTable(false)
        // setIsLoading(false);
        notAllowMsgCheck(e)
      })
  }

  async function getRepOutletsRegistersService (featureID) {
    await ds
      .getRepOutRegs({}, BEHAVIOUR_TYPE.GET, featureID)
      .then(qw => {
        setIsLoading(false)
        if (qw && qw.length > 0) {
          const reg = [{ registerID: 'xxx', registerName: 'All Registers' }]
          qw.map(ee => {
            ee.registers &&
              ee.registers.length > 0 &&
              ee.registers.map(ff => {
                reg.push(ff)
              })
          })
          setRegData(reg && reg.length > 0 ? reg : [])
          qw.splice(0, 0, { outletID: 'xxx', outletName: 'All Outlet' })
          setOutRegData(qw)
        }
      })
      .catch(e => {
        setIsLoading(false)
        notAllowMsgCheck(e)
      })
  }

  const handleTableChange = (pagination, filters, sorter) => {
    let getRegID = ''
    let getOutletID = ''
    const value = {
      Register: form.getFieldValue('Register'),
      Outlet: form.getFieldValue('Outlet')
    }
    if (value.Register !== '' && value.Outlet !== '') {
      try {
        setLoadingTable(true)
        getRegID = value.Register === 'xxx' ? getRegID : value.Register
        if (getOutletDisabled) {
          const outID =
            getRegData.filter(
              a => getDecryptID(a.registerID) === getDecryptID(value.Register)
            ).length > 0
              ? getRegData.filter(
                  a =>
                    getDecryptID(a.registerID) === getDecryptID(value.Register)
                )[0].outletID
              : ''
          getOutletID = outID
        } else {
          getOutletID = value.Outlet === 'xxx' ? getOutletID : value.OutletID
        }
        let body = {
          CurrentPageNo: pagination.current,
          PageSize: pagination.pageSize,
          RegID: getRegID,
          OutletID: getOutletID
        }
        getRegClosureListingService(body, PkgFeatures.ReportingAndAnalytics)
      } catch (e) {
        setLoadingTable(false)
      }
    } else {
      message.warn('Connection lost, kindly refresh page')
    }
  }

  // const columns = [
  //   {
  //     title: <IntlMessages id="reporting.registerclosures.register" />,
  //     dataIndex: "register",
  //     key: "register",
  //   },
  //   {
  //     title: <IntlMessages id="reporting.registerclosures.hash" />,
  //     dataIndex: "hash",
  //     key: "hash",
  //   },
  //   {
  //     title: <IntlMessages id="reporting.registerclosures.timeopened" />,
  //     dataIndex: "timeOpened",
  //     key: "timeOpened",
  //     render: (text, record) => (
  //       <span>
  //         <a
  //           onClick={() => history.push(`/dashboard/reporting/registerclosures/summary/${record.cashManagementID}`, record)}
  //           // href={"/Dashboard/products/supplier/view/" + record.key}
  //           className="gx-link"
  //         >
  //           {text}
  //         </a>
  //       </span>
  //     ),
  //   },
  //   {
  //     title: <IntlMessages id="reporting.registerclosures.timeclosed" />,
  //     dataIndex: "timeClosed",
  //     key: "timeClosed",
  //   },
  //   {
  //     title: <IntlMessages id="reporting.registerclosures.storecredit" />,
  //     dataIndex: "storeCredit",
  //     key: "storeCredit",
  //   },
  //   {
  //     title: <IntlMessages id="reporting.registerclosures.storecredit" />,
  //     dataIndex: "loyalty",
  //     key: "loyalty",
  //   },
  //   {
  //     title: <IntlMessages id="reporting.registerclosures.cash" />,
  //     dataIndex: "cash",
  //     key: "cash",
  //   },
  //   {
  //     title: <IntlMessages id="reporting.registerclosures.total" />,
  //     dataIndex: "total",
  //     key: "total",
  //   },
  // ];

  const onFinish = value => {
    if (value.Register !== '' && value.Outlet !== '') {
      try {
        setLoadingTable(true)
        let getRegID = ''
        let getOutletID = ''
        getRegID = value.Register === 'xxx' ? getRegID : value.Register
        if (getOutletDisabled) {
          const outID =
            getRegData.filter(
              a => getDecryptID(a.registerID) === getDecryptID(value.Register)
            ).length > 0
              ? getRegData.filter(
                  a =>
                    getDecryptID(a.registerID) === getDecryptID(value.Register)
                )[0].outletID
              : ''
          getOutletID = outID
        } else {
          getOutletID = value.Outlet === 'xxx' ? getOutletID : value.Outlet
        }
        const body = {
          CurrentPageNo: 1,
          PageSize: 10,
          RegID: getRegID,
          OutletID: getOutletID
        }
        getRegClosureListingService(body, PkgFeatures.ReportingAndAnalytics)
      } catch (e) {
        setLoadingTable(false)
      }
    } else {
      message.warn('Lost Connection, kindly refresh page')
    }
  }

  function onRegSelect (e) {
    if (e === 'xxx') {
      setOutletDisabled(false)
    } else {
      setOutletDisabled(true)
    }
  }

  function onOutSelect (e) {
    const data = getOutRegData
    const reg = []
    data.map(ee => {
      ee.registers &&
        ee.registers.length > 0 &&
        ee.registers.map(ff => {
          reg.push(ff)
        })
    })
    const regData =
      e === 'xxx'
        ? reg
        : reg.filter(xx => getDecryptID(xx.outletID) === getDecryptID(e))
    regData.splice(0, 0, { registerID: 'xxx', registerName: 'All Registers' })
    setRegData(regData && regData.length > 0 ? regData : [])
  }

  return getIsAllowRead && isFeatureAllowed ? (
    <div className='Content-wrapper RegisterClosures-pg'>
      {checkIsWeb().exist && (
        <Row>
          <Col span={24}>
            <h1 className=''>
              <IntlMessages id='reporting.registerclosures.registerclosures' />
            </h1>
          </Col>
        </Row>
      )}

      <Spin
        // tip={<IntlMessages id="sell.cashlisting.loadcash" />}
        spinning={isLoading}
        size='large'
      >
        <Card className='gx-card Filters-wrapper No-BoxShadow'>
          <Form
            {...formItemLayout}
            form={form}
            name={'RegClosureForm'}
            className='ant-advanced-search-form product-search-form Filters-Form'
            layout='horizontal'
            onFinish={onFinish}
            initialValues={{
              Outlet: 'xxx',
              Register: 'xxx'
            }}
          >
            <Row>
              <Col lg={12} md={12} sm={24} xs={24}>
                <Form.Item
                  className='ant-form-item-label-custom'
                  name={'Register'}
                  label={
                    <IntlMessages id='reporting.registerclosures.register' />
                  }
                >
                  <Select
                    onSelect={onRegSelect}
                    showSearch={checkIsWeb().exist}
                    optionFilterProp='children'
                  >
                    {getRegData &&
                      getRegData.length > 0 &&
                      getRegData.map((e, key) => {
                        return (
                          <Select.Option key={key} value={e.registerID}>
                            {e.registerName}
                          </Select.Option>
                        )
                      })}
                  </Select>
                </Form.Item>
              </Col>

              <Col lg={12} md={12} sm={24} xs={24}>
                <Form.Item
                  className='ant-form-item-label-custom'
                  name={'Outlet'}
                  label={
                    <IntlMessages id='reporting.registerclosures.outlet' />
                  }
                >
                  <Select
                    onSelect={onOutSelect}
                    disabled={getOutletDisabled}
                    showSearch={checkIsWeb().exist}
                    optionFilterProp='children'
                  >
                    {getOutRegData &&
                      getOutRegData.length > 0 &&
                      getOutRegData.map((e, key) => {
                        return (
                          <Select.Option key={key} value={e.outletID}>
                            {e.outletName}
                          </Select.Option>
                        )
                      })}
                  </Select>
                </Form.Item>
              </Col>

              <Col lg={24} md={24} sm={24} xs={24}>
                <Button
                  className='float-right'
                  htmlType='submit'
                  type='primary'
                  size='middle'
                >
                  <IntlMessages id='products.main.listingtable.search' />
                </Button>
              </Col>
            </Row>
          </Form>
        </Card>
      </Spin>
      {tabLoader ? (
        <Skeleton count={8} height={30} />
      ) : (
        <>
          <Table
            // style={{ marginTop: -16 }}
            className='gx-table-responsive custom-product-table'
            columns={columns}
            dataSource={getRegClosureData}
            pagination={getPagination}
            onChange={handleTableChange}
            loading={getLoadingTable}
          />
        </>
      )}
    </div>
  ) : (
    <NotAllowedComponent
      getAccessLoading={getAccessLoading}
      textType={!isFeatureAllowed ? 2 : 1}
    />
  )
}

export default RegisterClosuresListing
